import type { Insight, Signal } from '../types';

const ins102Signals: Signal[] = [
  {
    id: 'S-10201',
    title: 'AUTH-482 — User authentication refactor',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 22, 2026',
  },
  {
    id: 'S-10202',
    title: 'PLAT-319 — API gateway rate limiting',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 21, 2026',
  },
  {
    id: 'S-10203',
    title: 'DATA-774 — ETL pipeline optimisation',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 21, 2026',
  },
  {
    id: 'S-10204',
    title: 'MOB-156 — Push notification service',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 20, 2026',
  },
  {
    id: 'S-10205',
    title: 'SRCH-088 — Full-text search indexing',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 20, 2026',
  },
  {
    id: 'S-10206',
    title: 'UI-601 — Dashboard widget redesign',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 19, 2026',
  },
  {
    id: 'S-10207',
    title: 'INTG-247 — Salesforce connector v2',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 19, 2026',
  },
  {
    id: 'S-10208',
    title: 'PERF-390 — Database query optimisation',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 18, 2026',
  },
  {
    id: 'S-10209',
    title: 'SEC-112 — OAuth 2.0 token refresh',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 18, 2026',
  },
  {
    id: 'S-10210',
    title: 'ONBRD-055 — Guided setup wizard',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 17, 2026',
  },
  {
    id: 'S-10211',
    title: 'NOTIF-403 — Email digest scheduler',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 17, 2026',
  },
  {
    id: 'S-10212',
    title: 'RPT-867 — Custom report export PDF',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 16, 2026',
  },
  {
    id: 'S-10213',
    title: 'BILL-234 — Invoice generation service',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 16, 2026',
  },
  {
    id: 'S-10214',
    title: 'PERM-078 — Role-based access control',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 15, 2026',
  },
  {
    id: 'S-10215',
    title: 'SRCH-091 — Typeahead autocomplete',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 15, 2026',
  },
  {
    id: 'S-10216',
    title: 'MOB-162 — Offline sync conflict resolution',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 14, 2026',
  },
  {
    id: 'S-10217',
    title: 'DATA-781 — Schema migration v14',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 14, 2026',
  },
  {
    id: 'S-10218',
    title: 'INTG-251 — Jira webhook processor',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 13, 2026',
  },
  {
    id: 'S-10219',
    title: 'UI-608 — Gantt chart drag interactions',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 13, 2026',
  },
  {
    id: 'S-10220',
    title: 'PLAT-325 — Service mesh configuration',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 12, 2026',
  },
  {
    id: 'S-10221',
    title: 'AUTH-489 — SSO SAML integration',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 12, 2026',
  },
  {
    id: 'S-10222',
    title: 'PERF-397 — Redis cache warming',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 11, 2026',
  },
  {
    id: 'S-10223',
    title: 'SEC-118 — Audit log tamper detection',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 11, 2026',
  },
  {
    id: 'S-10224',
    title: 'RPT-872 — Scheduled report delivery',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 10, 2026',
  },
  {
    id: 'S-10225',
    title: 'NOTIF-408 — Slack webhook integration',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 10, 2026',
  },
  {
    id: 'S-10226',
    title: 'ONBRD-059 — Trial activation flow',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 9, 2026',
  },
  {
    id: 'S-10227',
    title: 'BILL-239 — Proration calculation engine',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 9, 2026',
  },
  {
    id: 'S-10228',
    title: 'DATA-788 — Real-time aggregation pipeline',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 8, 2026',
  },
  {
    id: 'S-10229',
    title: 'UI-614 — Accessibility audit fixes',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 8, 2026',
  },
  {
    id: 'S-10230',
    title: 'PERM-084 — Team scoping middleware',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 7, 2026',
  },
  {
    id: 'S-10231',
    title: 'MOB-168 — Biometric authentication',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 7, 2026',
  },
  {
    id: 'S-10232',
    title: 'PLAT-331 — Feature flag service',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 6, 2026',
  },
  {
    id: 'S-10233',
    title: 'SRCH-095 — Relevance ranking tuning',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 6, 2026',
  },
  {
    id: 'S-10234',
    title: 'INTG-256 — Workday HR sync connector',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 5, 2026',
  },
  {
    id: 'S-10235',
    title: 'SEC-123 — Session timeout enforcement',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 5, 2026',
  },
  {
    id: 'S-10236',
    title: 'RPT-878 — Pivot table renderer',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 4, 2026',
  },
  {
    id: 'S-10237',
    title: 'PERF-403 — CDN cache invalidation',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 4, 2026',
  },
  {
    id: 'S-10238',
    title: 'BILL-244 — Dunning management flow',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 3, 2026',
  },
  {
    id: 'S-10239',
    title: 'AUTH-494 — Password policy enforcement',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 3, 2026',
  },
  {
    id: 'S-10240',
    title: 'DATA-793 — Event sourcing replay',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 2, 2026',
  },
  {
    id: 'S-10241',
    title: 'UI-619 — Dark mode token migration',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 2, 2026',
  },
  {
    id: 'S-10242',
    title: 'NOTIF-413 — In-app notification centre',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 1, 2026',
  },
  {
    id: 'S-10243',
    title: 'PLAT-337 — Distributed tracing setup',
    type: 'Estimation',
    source: 'Jira',
    collected: 'Apr 1, 2026',
  },
];

const ins103Signals: Signal[] = [
  {
    id: 'S-10301',
    title: 'PLAT-Epic-12 — Platform Observability Overhaul',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 22, 2026',
  },
  {
    id: 'S-10302',
    title: 'MOB-Epic-07 — Mobile Offline Mode',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 20, 2026',
  },
  {
    id: 'S-10303',
    title: 'AUTH-Epic-03 — Enterprise SSO Rollout',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 18, 2026',
  },
  {
    id: 'S-10304',
    title: 'DATA-Epic-15 — Data Warehouse Migration',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 15, 2026',
  },
  {
    id: 'S-10305',
    title: 'UI-Epic-09 — Design System Token Migration',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 12, 2026',
  },
  {
    id: 'S-10306',
    title: 'INTG-Epic-04 — Partner API v3 Upgrade',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 9, 2026',
  },
  {
    id: 'S-10307',
    title: 'SRCH-Epic-06 — Search Relevance Engine',
    type: 'Scheduling',
    source: 'Jira',
    collected: 'Apr 6, 2026',
  },
];

const ins104Signals: Signal[] = [
  {
    id: 'S-10401',
    title: 'AUTH-318 — OAuth token refresh logic',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 22, 2026',
  },
  {
    id: 'S-10402',
    title: 'PLAT-504 — Service discovery configuration',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 21, 2026',
  },
  {
    id: 'S-10403',
    title: 'DATA-662 — Schema migration v15 rollout',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 20, 2026',
  },
  {
    id: 'S-10404',
    title: 'MOB-231 — Offline sync conflict resolver',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 19, 2026',
  },
  {
    id: 'S-10405',
    title: 'INTG-388 — Salesforce field mapping update',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 17, 2026',
  },
  {
    id: 'S-10406',
    title: 'UI-713 — Design token global rollout',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 16, 2026',
  },
  {
    id: 'S-10407',
    title: 'SRCH-142 — Index rebuild for v2 schema',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 14, 2026',
  },
  {
    id: 'S-10408',
    title: 'SEC-207 — Certificate rotation automation',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 12, 2026',
  },
  {
    id: 'S-10409',
    title: 'RPT-491 — Report aggregation pipeline fix',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 10, 2026',
  },
  {
    id: 'S-10410',
    title: 'BILL-325 — Subscription state machine refactor',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 8, 2026',
  },
  {
    id: 'S-10411',
    title: 'NOTIF-174 — Delivery queue retry logic',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 5, 2026',
  },
  {
    id: 'S-10412',
    title: 'PERF-558 — CDN routing rule update',
    type: 'Bottleneck',
    source: 'Jira',
    collected: 'Apr 3, 2026',
  },
];

const ins105Signals: Signal[] = [
  {
    id: 'S-10501',
    title: 'PROJ-814 — Legacy reporting module cleanup',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 22, 2026',
  },
  {
    id: 'S-10502',
    title: 'UI-302 — Admin panel colour refresh',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 21, 2026',
  },
  {
    id: 'S-10503',
    title: 'DATA-119 — Log retention policy update',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 20, 2026',
  },
  {
    id: 'S-10504',
    title: 'PLAT-447 — Internal tooling script migration',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 19, 2026',
  },
  {
    id: 'S-10505',
    title: 'MOB-388 — Deprecated SDK warning suppression',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 18, 2026',
  },
  {
    id: 'S-10506',
    title: 'RPT-056 — Unused dashboard widget removal',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 17, 2026',
  },
  {
    id: 'S-10507',
    title: 'AUTH-721 — Test environment credential rotation',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 15, 2026',
  },
  {
    id: 'S-10508',
    title: 'INTG-093 — Archived connector configuration',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 14, 2026',
  },
  {
    id: 'S-10509',
    title: 'SRCH-267 — Experimental ranking model spike',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 12, 2026',
  },
  {
    id: 'S-10510',
    title: 'PERF-334 — One-off load test environment setup',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 11, 2026',
  },
  {
    id: 'S-10511',
    title: 'NOTIF-512 — Unlinked email template draft',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 9, 2026',
  },
  {
    id: 'S-10512',
    title: 'BILL-178 — Orphaned discount rule investigation',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 8, 2026',
  },
  {
    id: 'S-10513',
    title: 'SEC-449 — Informal pen test remediation notes',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 7, 2026',
  },
  {
    id: 'S-10514',
    title: 'UI-638 — Unapproved design exploration spike',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 6, 2026',
  },
  {
    id: 'S-10515',
    title: 'DATA-583 — Unclassified data lake folder audit',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 5, 2026',
  },
  {
    id: 'S-10516',
    title: 'PLAT-662 — Dev environment parity investigation',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 4, 2026',
  },
  {
    id: 'S-10517',
    title: 'MOB-415 — Untracked accessibility regression fix',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 3, 2026',
  },
  {
    id: 'S-10518',
    title: 'PROJ-901 — Informal stakeholder demo prep work',
    type: 'Resource Allocation',
    source: 'Jira',
    collected: 'Apr 2, 2026',
  },
];

export const MOCK_INSIGHTS: Insight[] = [
  {
    id: 105,
    type: 'risk',
    category: 'misalignment',
    title:
      '23% of your portfolio does not contribute to a top level strategic goal for the organization.',
    description:
      '18 work items were discovered which do not contribute to a priority initiative or strategic goal. This can be due to parenting errors or misaligned work that was added outside of normal planning cycles. Work without strategic alignment cannot be measured for ROI, creates noise in capacity planning, and reduces the signal quality of portfolio health reporting.',
    showMyWork:
      'Misaligned work is calculated by scanning each work item and their hierarchy. If at any point the parenting structure breaks before reaching the top level strategic objective, the work item is flagged as having a misalignment or not contributing to a strategic objective.',
    confidence: 'high',
    impact: 'critical',
    generatedAt: '2026-05-02T10:00:00Z',
    objectiveId: null,
    signals: ins105Signals,
  },
  {
    id: 104,
    type: 'risk',
    category: 'blocker',
    title: '12 Work items are blocked, 5 of which are high priority Epics.',
    description:
      'Successors and predecessors of work items within your portfolio were analyzed and found 12 work items with incomplete predecessors who are blocking progress. These blockers are preventing dependent work from starting or continuing, creating compounding delays across multiple teams and initiatives.',
    showMyWork:
      'Blocked work items are calculated by reviewing all successors and predecessors of a work item. If a predecessor of a work item is flagged as late, then the work item is marked as blocked by its predecessor and contributes to this calculation. The calculation also factors in "is blocked" link types from Jira. High priority Epics which have blocked or blocking work items are flagged.',
    confidence: 'high',
    impact: 'critical',
    generatedAt: '2026-05-03T10:00:00Z',
    objectiveId: null,
    signals: ins104Signals,
  },
  {
    id: 103,
    type: 'risk',
    category: 'delivery-risk',
    title: '7 Epics are forecasted to miss their deadline.',
    description:
      '7 Epics have a forecast complete date that exceeds their latest end date. Based on current velocity and remaining scope, these Epics will not be delivered within their planned window. If left unaddressed, missed Epic deadlines will cascade into dependent initiatives and compress downstream delivery schedules.',
    showMyWork:
      "A work item's forecasted end date is calculated by using the assigned team's completion rate and drawing a trend line out until the completed work equals work remaining. If the forecasted end date is past the expected end date, the work item is flagged as expected to miss its deadline.",
    confidence: 'high',
    impact: 'critical',
    generatedAt: '2026-05-03T09:00:00Z',
    objectiveId: null,
    signals: ins103Signals,
  },
  {
    id: 102,
    type: 'trend',
    category: 'resource-allocation',
    title: '17% of your portfolio has been under-estimated for the past 2 sprints.',
    description:
      '43 work items (17%) have a greater time spent than time planned. This implies that these work items have been under-estimated in terms of effort. Repeated under-estimation across two consecutive sprints suggests a systemic planning gap — not isolated incidents. If left unaddressed, this pattern will continue to compress delivery timelines, inflate actual costs, and reduce the reliability of future sprint forecasts.',
    showMyWork:
      "Under-estimation is calculated by taking the time spent value and comparing it against time planned, which is derived from the midpoint of the work item's t-shirt estimate size. If time spent exceeds time planned, the work item is flagged as under-estimated — more time was consumed than the estimate accounted for. This pattern across 43 work items over 2 consecutive sprints indicates a systemic gap in estimation accuracy rather than isolated outliers.",
    confidence: 'medium',
    impact: 'significant',
    generatedAt: '2026-05-03T08:00:00Z',
    objectiveId: null,
    signals: ins102Signals,
  },
];
